/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { z } from "zod";

/**
 * @description Успешно
 */
export const getApiTestDeeplink200Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const getApiTestDeeplink400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const getApiTestDeeplink401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const getApiTestDeeplink403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const getApiTestDeeplink500Schema = z.lazy(() => badResponseModelSchema)

export const getApiTestDeeplinkQueryResponseSchema = z.lazy(() => getApiTestDeeplink200Schema)